import { getIsProductAdminFromQuery } from './getIsProductAdminFromQuery';
import { getIsSiteAdminFromQuery } from './getIsSiteAdminFromQuery';
import { UserPrivilege } from './UserPrivilege';

type GetUserPrivilegeFromQueryParam = {
	readonly isSiteAdmin?: boolean | null;
	readonly user?: {
		readonly confluence?: {
			readonly operations?: ReadonlyArray<
				| {
						readonly operation?: string | null;
						readonly targetType?: string | null;
				  }
				| null
				| undefined
			> | null;
		} | null;
	} | null;
} | null;

export function getUserPrivilegeFromQuery(
	queryData: GetUserPrivilegeFromQueryParam | undefined,
): UserPrivilege | undefined {
	const isSiteAdmin = getIsSiteAdminFromQuery(queryData);
	const isProductAdmin = getIsProductAdminFromQuery(queryData);

	return typeof queryData === 'undefined'
		? undefined
		: isSiteAdmin
			? UserPrivilege.SITE_ADMIN
			: isProductAdmin
				? UserPrivilege.PRODUCT_ADMIN
				: UserPrivilege.NON_ADMIN;
}
